export const USER_LOAD_REQUEST = 'USER_LOAD_REQUEST';
export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS';
export const USER_LOAD_FAILURE = 'USER_LOAD_FAILURE';

export const ADD_REPORT_TO_USER = 'ADD_REPORT_TO_USER';
export const REMOVE_REPORT_FROM_USER = 'REMOVE_REPORT_FROM_USER';

export const UPDATE_USER_REPORTS_REQUEST = 'UPDATE_USER_REPORTS_REQUEST';
export const UPDATE_USER_REPORTS_SUCCESS = 'UPDATE_USER_REPORTS_SUCCESS';
export const UPDATE_USER_REPORTS_FAILURE = 'UPDATE_USER_REPORTS_FAILURE';
